import './slick-slider.css';
import './imageViewer.css';
import './azureMediaPlayer.css';
import './redactor.css';
